import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Vibe Inspector · Your Guide to D.C.</p>
        <h1>Discover the Best of D.C. Nightlife and Dining</h1>
        <p className="lede">
          Explore the vibrant restaurant and nightlife scene in Washington, D.C. Whether you're a local or a visitor, find the perfect spot to eat, drink, and unwind.
        </p>
        <div className="cta-row">
          <a href="/restaurants" target="_self">
            Explore Restaurants
          </a>
          <a href="/nightlife" target="_self" className="secondary">
            Discover Nightlife
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Top Dining Experiences</h2>
          <p>
            From cozy cafes to upscale dining, uncover the best places to satisfy your cravings in the heart of D.C.
          </p>
        </article>
        <article>
          <h2>Vibrant Nightlife</h2>
          <p>
            Experience the energy of D.C. after dark. Find bars, clubs, and live music venues that keep the city alive.
          </p>
        </article>
        <article>
          <h2>Curated Recommendations</h2>
          <p>
            Get personalized suggestions based on your tastes and preferences. Let us guide you to your next favorite spot.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;